
import { useQuery } from "@tanstack/react-query";
import { getUpcomingProducts } from "@/services/recurring-products.service";

export const useUpcomingProducts = (daysThreshold: number = 7) => {
  const { data: products = [], isLoading } = useQuery({
    queryKey: ['upcoming-products', daysThreshold],
    queryFn: () => getUpcomingProducts(daysThreshold),
  });

  return {
    products,
    isLoading
  };
};
